import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogContent from '@material-ui/core/DialogContent';
import {useTranslation} from 'react-i18next';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import PropTypes from 'prop-types';
import {useShellPortDelete} from '../../../hooks/useShells';
import RichAlert from '../../core/feedback/RichAlert';
import Button from '../../core/input/Button';
import {useSetSnackbar} from '../../../hooks/useSnackbar';

const DeleteShellPortDialog = ({port, open, setOpen, refreshList, refreshing}) => {
	const {t} = useTranslation();
	const [deletePort, deleting] = useShellPortDelete(port?.Shell_Port__);
	const setSnackbar = useSetSnackbar();

	const handleClose = () => {
		setOpen(null);
	};

	const handleDelete = e => {
		e.preventDefault();

		deletePort()
			.then(() => {
				setSnackbar(t('shell_port_delete_success'), 'success');
			})
			.then(() => refreshList())
			.then(handleClose);
	};

	return (<Dialog
		open={open}
		aria-labelledby={t('dialog_delete_shell_port_key_title')}
		aria-describedby={t('dialog_delete_shell_port_key_title')}
	>
		<DialogTitle id='delete-shellport-title'>
			{t('dialog_delete_shell_port_key_title')}
		</DialogTitle>
		<DialogContent>
			<DialogContentText id='delete-shellport-description'>
				<RichAlert severity='warning'>
					{t('dialog_delete_shell_port_description', {
						name: port.Name,
						host: port.Guest_Port,
						external: port.Extern_Port
					})}
				</RichAlert>
			</DialogContentText>
		</DialogContent>
		<DialogActions>
			<Button
				color='default'
				onClick={handleClose}
				disabled={deleting || refreshing}
			>
				{t('close_btn')}
			</Button>
			<Button
				onClick={handleDelete}
				color='secondary'
				variant='outlined'
				disabled={deleting || refreshing}
				loading={deleting || refreshing}
			>
				{t('delete_btn')}
			</Button>
		</DialogActions>
	</Dialog>);
};

export default DeleteShellPortDialog;

DeleteShellPortDialog.propTypes = {
	port: PropTypes.object,
	open: PropTypes.bool.isRequired,
	refreshList: PropTypes.func.isRequired,
	refreshing: PropTypes.bool.isRequired,
	setOpen: PropTypes.func.isRequired
};
